import type {
  DashboardCompactSearchToolPayload,
  DashboardContextResultPayload,
  DashboardDonationSummaryToolPayload,
  DashboardNavigationResultPayload,
  DashboardSearchResultPayload,
  DashboardToolErrorPayload,
} from '../types';

export function parseDashboardSearchResult(content: string): DashboardSearchResultPayload | null {
  const trimmed = content.trim();
  if (!trimmed.startsWith('{') || !trimmed.endsWith('}')) {
    return null;
  }

  try {
    const parsed = JSON.parse(trimmed) as DashboardSearchResultPayload;
    if (parsed?.status !== 'ok' || !parsed.results || typeof parsed.query !== 'string') {
      return null;
    }

    return parsed;
  } catch {
    return null;
  }
}

export function parseDashboardCompactSearchToolResult(
  content: string,
): DashboardCompactSearchToolPayload | null {
  const trimmed = content.trim();
  if (!trimmed.startsWith('{') || !trimmed.endsWith('}')) {
    return null;
  }

  try {
    const parsed = JSON.parse(trimmed) as DashboardCompactSearchToolPayload;
    if (
      !['ok', 'needs_disambiguation', 'not_found'].includes(String(parsed?.status)) ||
      typeof parsed.query !== 'string' ||
      typeof parsed.resultCount !== 'number' ||
      !parsed.topResults
    ) {
      return null;
    }

    return parsed;
  } catch {
    return null;
  }
}

export function parseDashboardNavigationResult(
  content: string,
): DashboardNavigationResultPayload | null {
  const trimmed = content.trim();
  if (!trimmed.startsWith('{') || !trimmed.endsWith('}')) {
    return null;
  }

  try {
    const parsed = JSON.parse(trimmed) as DashboardNavigationResultPayload;
    if (parsed?.status !== 'opened' || typeof parsed.path !== 'string') {
      return null;
    }

    return parsed;
  } catch {
    return null;
  }
}

export function parseDashboardContextResult(
  content: string,
): DashboardContextResultPayload | null {
  const trimmed = content.trim();
  if (!trimmed.startsWith('{') || !trimmed.endsWith('}')) {
    return null;
  }

  try {
    const parsed = JSON.parse(trimmed) as DashboardContextResultPayload;
    if (!parsed?.route || typeof parsed.route.pathname !== 'string') {
      return null;
    }

    return parsed;
  } catch {
    return null;
  }
}

export function parseDashboardToolError(content: string): DashboardToolErrorPayload | null {
  const trimmed = content.trim();
  if (!trimmed.startsWith('{') || !trimmed.endsWith('}')) {
    return null;
  }

  try {
    const parsed = JSON.parse(trimmed) as DashboardToolErrorPayload;
    if (parsed?.status !== 'error' || typeof parsed.message !== 'string') {
      return null;
    }

    return parsed;
  } catch {
    return null;
  }
}

export function parseDashboardDonationSummaryToolResult(
  content: string,
): DashboardDonationSummaryToolPayload | null {
  const trimmed = content.trim();
  if (!trimmed.startsWith('{') || !trimmed.endsWith('}')) {
    return null;
  }

  try {
    const parsed = JSON.parse(trimmed) as DashboardDonationSummaryToolPayload;
    if (
      !['ok', 'no_donations'].includes(String(parsed?.status)) ||
      !('donationSummary' in parsed) ||
      !parsed.contact
    ) {
      return null;
    }

    return parsed;
  } catch {
    return null;
  }
}
